import { render, staticRenderFns } from "./_attached_files_from_my_relatico_form.vue?vue&type=template&id=dd72e478&scoped=true&"
import script from "./_attached_files_from_my_relatico_form.vue?vue&type=script&lang=js&"
export * from "./_attached_files_from_my_relatico_form.vue?vue&type=script&lang=js&"
import style0 from "./_attached_files_from_my_relatico_form.vue?vue&type=style&index=0&id=dd72e478&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd72e478",
  null
  
)

export default component.exports